// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Mee","col":"styles_col__3_OSO","actions":"styles_actions__fnAgA","conflict":"styles_conflict__Mndd9"};